const state = {
  status: null,
  message: '',
  code: 0
};


const getters = {
  getStatus(){
    return state.status;
  },
  getMessage(){
    return state.message;
  },

  getCode() {
    return state.message;
  }
};


const mutations = {
  setStatus (state, payload) {
    state.status = payload.status;
    state.message = payload.message;
  },
  resetStatus (){
    state.status = null;
    state.message = '';
  }
};


const actions = {
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/status.js